
export class Mot_defil {
    id_mot:number;
    contenue_mot:any;
    etat_mot:any;
    date_ajout:Date;
   
    
       
    constructor(id_mot:number){
           
    }
}
